import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import './Galeria.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { apiUrl, authorizationBasicToken } from "../../config.js";

import Image1 from "../../assets/galeria/intro1.png"
import Image2 from "../../assets/galeria/intro2.png"
import Image3 from "../../assets/galeria/intro3.png"
import Image4 from "../../assets/galeria/intro4.png"
import Image5 from "../../assets/galeria/intro5.png"
import Image6 from "../../assets/galeria/intro6.png"

const images = [
  {
    id: 1,
    src: Image1,
  },
  {
    id: 2,
    src: Image2,
  },
  {
    id: 3,
    src: Image3,
  },
  {
    id: 4,
    src: Image4,
  },
  {
    id: 5,
    src: Image5,
  },
  {
    id: 6,
    src: Image6,
  },
];

const GaleriaComponent = () => {

  const headers = {
    'Authorization': authorizationBasicToken,
    'Content-Type': 'application/json'
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    getGaleria();
  }, []);

  const getGaleria = async () => {
    axios.get(`${apiUrl}/home-galeria`, {
      headers: headers,
    })
      .then((response) => setData(
        response.data && response.data?.data.length ? response.data.data.sort((a, b) => (a.ordem > b.ordem ? 1 : -1)) : [])
      )
      .catch((error) => console.error('Erro ao buscar dados:', error));
  };

  const [expandedImage, setExpandedImage] = useState(null);

  const handleImageClick = (image) => {
    setExpandedImage(apiUrl + '/' + image.imagem);
  };

  const handleCloseExpandedImage = () => {
    setExpandedImage(null);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    className: 'custom-slide',
    nextArrow: <></>,
    prevArrow: <></>,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fcf9f4",
          padding: "40px",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            fontFamily: "Fredoka One",
            textAlign: "center",
            marginBottom: "1px",
            color: "#271344",
            fontSize: "36px",
          }}
        >
          Galeria de Imagem
        </h3>
      </div>
      <Slider style={{ marginTop: '60px' }} {...settings}>
        {data?.map((image) => (
          <div key={image.id} style={{ marginBottom: '10px', borderRadius: '10px', overflow: 'hidden', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
            <div
              style={{
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '10px 10px 0 0',
              }}
              onClick={() => handleImageClick(image)}
            >
              <img src={apiUrl + '/' + image.imagem} alt={`Imagem ${image.id}`} style={{ width: '100%', height: 'auto' }} />
            </div>
          </div>
        ))}
      </Slider>

      {expandedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1101
          }}
          onClick={handleCloseExpandedImage}
        >
          <div style={{ maxWidth: '90%', maxHeight: '90%' }}>
            <img src={expandedImage} alt="Imagem expandida" style={{ width: '100%', height: 'auto' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default GaleriaComponent;
